(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'headerDegree', {
            bindings: {
                qual: '<'
            },
            templateUrl: 'app/views/partials/layout/header-degree.html',
            controller:  HeaderDegreeController,
            controllerAs:'vm'
        });

    /**
     * Renders NEW header that's common for all the views on the Degrees.
     *
     * @type {ng.IController}
     *
     * @param {ng.IScope} $scope
     * @param {ng.IElement} $element
     * @param {ng.ITimeout} $timeout
     * @param {LoggerFactory} LoggerFactory
     * @param {DataService} DataService
     * @param {SubpagesService} SubpagesService
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function HeaderDegreeController(
        $scope,
        $animate,
        $element,
        LoggerFactory,
        DataService,
        SubpagesService,
        TEXTS,
        CONFIG
    ){
        // Helper members.

        /** @type {ng.IController} */
        var vm = this;

        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'DegreeHeader' );


        /** Constants. */

        var INPUT_SEARCH_ID     = 'search-query',
        FORM_SEARCH_CLASS       = 'search-form';


        /** Expose to the Scope */

        $scope._        = TEXTS.HEADER;
        $scope.CONFIG   = CONFIG;


        /** Controller's API */

        vm.toggleHeaderPanel = toggleHeaderPanel;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        function init(){
            vm.headerPanelOpened = false;
            retrieveResponseAndBind();
        };

        vm.$onInit = init;

        // TODO - not necessary if the API sent through fullName instead of name for grad-qual..
        // Watch for qual data so we can replace..
        $scope.$watch('vm.qual', function(val) {
            if(val != undefined) {
                angular.extend(vm.qual, extendQual(vm.qual, "fullName", "name"));
            }
        });


        /* ===== PRIVATE FUNCTIONS ========================================== */
        
        function extendQual(original, test, replace) {
            var newObj = {};
            
            if(!vm.qual.hasOwnProperty(test)) {
                newObj[test] = original[replace];
            }

            return newObj;
        }


        function retrieveResponseAndBind(){
            DataService.getGlobals()
                .then( function( responseObject ) {
                    vm.header = responseObject.data;
                }).catch( function( errMessage ) {
                    logger.error( "Main site's global data couldn't be retrieved. Error: %s", errMessage );
                }
            );
        }



        function toggleHeaderPanel( shouldAutofocusSearchInput ) {
            shouldAutofocusSearchInput  = shouldAutofocusSearchInput || false;
            vm.headerPanelOpened        = !vm.headerPanelOpened;

            // Autofocus search input
            if ( vm.headerPanelOpened && shouldAutofocusSearchInput ) {
                autofocusSearchInput();
            }
        }


        function autofocusSearchInput() {
            var inputSearchElement  = angular.element( $element.find( '#' + INPUT_SEARCH_ID ) ),
            formSearchElement       = angular.element( $element.find( '.' + FORM_SEARCH_CLASS )[ 0 ] );

            $animate.on( 'removeClass', formSearchElement, function( element, phase ) {
                // phase = [ 'start', 'close' ]
                if ( phase === 'close' ) {
                    inputSearchElement.focus();  // Focus when animation finishes running
                    $animate.off( formSearchElement ); // Deregister
                }
            });
        }
    }


    HeaderDegreeController.$inject = [ '$scope', '$animate', '$element','LoggerFactory', 'DataService', 'SubpagesService', 'TEXTS', 'CONFIG' ];
})();
